import type { CourseId } from '~/data/courses'

export function mapCourseTitleToCourseId(title: string): CourseId | null {
  const lowerCaseTitle = title.toLowerCase()
  if (lowerCaseTitle.includes('fintech')) {
    return 'fif'
  }
  if (lowerCaseTitle.includes('m1')) {
    if (lowerCaseTitle.includes('javascript')) {
      return 'm1js'
    }
    if (lowerCaseTitle.includes('python')) {
      return 'm1py'
    }
    if (lowerCaseTitle.includes('sql')) {
      return 'm1sql'
    }
    if (lowerCaseTitle.includes('blockchain')) {
      return 'm1blockchain'
    }
  }
  if (lowerCaseTitle.includes('foundation certificate')) {
    if (lowerCaseTitle.includes('data analy')) {
      return 'fcda'
    }
    if (lowerCaseTitle.includes('digital marketing')) {
      return 'fcdm'
    }
    if (lowerCaseTitle.includes('software')) {
      return 'fcse'
    }
    if (lowerCaseTitle.includes('ui')) {
      return 'fcuiux'
    }
    if (lowerCaseTitle.includes('technology')) {
      return 'fctm'
    }
  }
  if (lowerCaseTitle.includes('certified associate')) {
    if (lowerCaseTitle.includes('data analy')) {
      return 'cada'
    }
    if (lowerCaseTitle.includes('data sc')) {
      return 'cads'
    }
    if (lowerCaseTitle.includes('business analy')) {
      return 'caba'
    }
    if (lowerCaseTitle.includes('back')) {
      return 'cabed'
    }
    if (lowerCaseTitle.includes('front')) {
      return 'cafed'
    }
    if (lowerCaseTitle.includes('penetration')) {
      return 'capt'
    }
    if (lowerCaseTitle.includes('software')) {
      return 'case'
    }
  }
  return null
}
